import React from 'react';
import PropTypes from 'prop-types';

const TaskCounter = ({ totalTasks }) => (
  <span className='task-counter'>
    {' '}
    {totalTasks} of {5} tasks
  </span>
);

TaskCounter.propTypes = {
  totalTasks: PropTypes.number.isRequired
};

export default TaskCounter;
